(() => {
  if (!document.querySelector(".lp-the_sock_code")) return;
jQuery(function ($) {
	
	$('a[href^="#"]').click(function () {
		var speed = 700;
		var href = $(this).attr("href");
		var target = $(href === "#" || href === "" ? 'html' : href);

		if (!target.length) return false;

		var position = target.offset().top;

		// scene_tab_item クラスがクリックされた要素に含まれている場合、8rem分オフセット
		if ($(this).hasClass('scene_tab_item')) {
			position -= parseFloat(getComputedStyle(document.documentElement).fontSize) * 8;
		}

		$("html, body").animate({ scrollTop: position }, speed, "swing");
		return false;
	});


	$(document).ready(function () {
  const $banner = $('.banner');
  const fadeInThreshold = $('.section_about').offset().top - $('.section_about').outerHeight();
  const footer = document.querySelector('footer');
  let footerVisible = false;
  let isBannerClosed = false;

  // スクロール量でフェードイン（footerが見えてなくて、閉じてない場合）
  $(window).on('scroll', function () {
    const scrollTop = $(window).scrollTop();

    if (isBannerClosed) return;

    if (scrollTop > fadeInThreshold && !footerVisible) {
      if (!$banner.is(':visible')) {
        $banner.fadeIn(600);
      }
    } else {
      if ($banner.is(':visible')) {
        $banner.fadeOut(600);
      }
    }
  });

  // footerの可視状態を監視
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      footerVisible = entry.isIntersecting;

      if (isBannerClosed) return;

      if (footerVisible) {
        $banner.fadeOut(600);
      } else {
        if ($(window).scrollTop() > fadeInThreshold) {
          $banner.fadeIn(600);
        }
      }
    });
  }, {
    threshold: 0.1
  });

  observer.observe(footer);

  // 閉じるボタンで完全非表示
		$('.banner_close_btn').on('click', function () {
			isBannerClosed = true;
			$banner.fadeOut(400);
		});
	});

	ScrollTrigger.create({
		trigger: '.section_about',
		start: 'top top',
		toggleClass: {targets: ".drawer_menu_btn", className: "active"},
	});
	ScrollTrigger.create({
		trigger: '.drawer_menu_btn_trigger',
		start: 'top top',
		toggleClass: {targets: ".drawer_menu_btn", className: "active"},
	});

	$('.drawer_menu_btn').on('click', function () {
		$('.drawer').addClass('active');
		$('.drawer_inner').css('display','block');
		setTimeout(function () {
			$('.drawer_inner').addClass('active');
		}, 500);
	});
	$('.drawer_close_btn').on('click', function () {
		$('.drawer').removeClass('active');
		$('.drawer_inner').removeClass('active');
		$('.drawer_inner').css('display','none');
	});
	$('.drawer_list_item_link').on('click', function () {
		$('.drawer').removeClass('active');
		$('.drawer_inner').removeClass('active');
		$('.drawer_inner').css('display','none');
	});

	$(".btn,.code_form_btn,.scroll_top").hover(
		function() {
			$(this).addClass("active")
		},
		function() {
			$(this).removeClass("active")
		}
	);


//	$('.movie_image_box').on('click', function (e) {
//		e.stopPropagation();
//		$('.modal').addClass('active active0');
//		$('body').addClass('active');
//	});


	$('.modal_movie_btn').on('click', function () {
		$('.modal').removeClass('active active0 active1 active2 active3');
		$('body').removeClass('active');
	});

	$('.copy_url').on('click', function () {
		$(this).addClass("active");
		setTimeout(function () {
			$('.copy_url').removeClass('active');
		}, 3000);
	});
	$('.coupon_code').on('click', function () {
		$(this).addClass("active");
		setTimeout(function () {
			$('.coupon_code').removeClass('active');
		}, 3000);
	});

	
	$(document).on('click', function (e) {
		if ($('.modal').hasClass('active')) {
			const $target = $(e.target);
			const isInsideAllowed = $target.closest('.modal_top_text, .modal_sns_item, .copy_url, .modal_movie_box, .modal_movie_btn').length > 0;
			if (!isInsideAllowed) {
				$('.modal').removeClass('active active0 active1 active2 active3');
				$('body').removeClass('active');
				$('.modal iframe').attr('src', '');
			}
		}
	});
	
$('.scene_box_item_btn, .scene_box_item_image, .movie_image_box').on('click', function (e) {
    e.stopPropagation();

    const sceneId = $(this).attr('id');
    const sceneIndex = sceneId.replace('active', '');

    const $modal = $('.modal');
    const $wrapper = $(`#movie${sceneIndex}`);
    const $iframe = $wrapper.find('iframe');

    const videoId = $iframe.data('video-id'); // data-video-id属性から取得

    // YouTube埋め込みURLを生成
    const youtubeSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

    // iframe をリセットして再生
    $iframe.attr('src', '');
    setTimeout(() => {
        $iframe.attr('src', youtubeSrc);
    }, 50);

    // モーダルのクラス切り替え
    $modal.removeClass(function (i, cls) {
        return (cls.match(/(^|\s)scene-\S+/g) || []).join(' ');
    }).addClass(`${sceneId} active`);

    $('body').addClass('active');
});
	
	

	$('.scene_box_item_btn, .scene_box_item_image').on('click', function (e) {
		e.stopPropagation();

		const sceneId = $(this).attr('id');
		const sceneIndex = sceneId.replace('active', '');

		const $modal = $('.modal');
		const $wrapper = $(`#movie${sceneIndex}`);
		const $iframe = $wrapper.find('iframe');

		const originalSrc = $iframe.data('src');

		// iframe をリセットして再生
		$iframe.attr('src', '');
		setTimeout(() => {
			$iframe.attr('src', originalSrc + '?autoplay=1&mute=1&controls=0&loop=1&playlist=' + extractVideoId(originalSrc));
		}, 50);

		// モーダルのクラス切り替え
		$modal.removeClass(function (i, cls) {
			return (cls.match(/(^|\s)scene-\S+/g) || []).join(' ');
		}).addClass(`${sceneId} active`);

		$('body').addClass('active');
	});

	function extractVideoId(url) {
		const match = url.match(/embed\/([^\?&]+)/);
		return match ? match[1] : '';
	}


	$('.code_form_btn').on('click', function (e) {
		e.stopPropagation();
		$('.code_modal').addClass('active');
		$('body').addClass('active');
		$('.code_modal_conainer').removeClass('active');

		const codeValue = $('.code_form_input').val();
		if (codeValue === 'TK68') {
			$('#code_modal_true').addClass('active');
		} else {
			$('#code_modal_false').addClass('active');
		}

	});

	$(document).on('click', function (e) {
		if ($('.code_modal').hasClass('active')) {
			const $target = $(e.target);
			const isInsideAllowed = $target.closest('.code_modal_inner').length > 0;
			if (!isInsideAllowed) {
				$('.code_modal').removeClass('active');
				$('body').removeClass('active');
			}
		}
	});
	$('.code_modal_close_btn').on('click', function (e) {
		e.stopPropagation();
		$('.code_modal').removeClass('active');
			$('body').removeClass('active');
	});
	$('.code_modal_btn').on('click', function (e) {
		e.stopPropagation();
		$('.code_modal').removeClass('active');
			$('body').removeClass('active');
	});

	function setupScrollTrigger() {
  // 必要な ScrollTrigger のみ削除
  const idsToKill = ["scene_tab", "choose1", "choose2", "choose3"];
  ScrollTrigger.getAll().forEach(trigger => {
    if (idsToKill.includes(trigger.vars.id)) {
      trigger.kill();
    }
  });

  // rem → px 変換
  const remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize) * 12;
  const remStPx = parseFloat(getComputedStyle(document.documentElement).fontSize) * 8.3;
  const remEnPx = parseFloat(getComputedStyle(document.documentElement).fontSize) * 4.1;

  // スマホサイズ（767px以下）の場合のみ ScrollTrigger を作成
  if (window.matchMedia("(max-width: 767px)").matches) {
    // section_scene に対する ScrollTrigger
    ScrollTrigger.create({
      id: "scene_tab",
      trigger: '.section_scene',
      start: 'top top',
      end: `bottom-=${remToPx} top`,
      toggleClass: {
        targets: '.scene_tab_box',
        className: 'active'
      }
    });

    // chooseX → sceneX の対応関係
    const pairs = [
      { triggerId: "#choose1", targetId: "#scene1", id: "choose1" },
      { triggerId: "#choose2", targetId: "#scene2", id: "choose2" },
      { triggerId: "#choose3", targetId: "#scene3", id: "choose3" }
    ];

    pairs.forEach(({ triggerId, targetId, id }) => {
      ScrollTrigger.create({
        id,
        trigger: triggerId,
        start: `top-=${remStPx} top`,
        end: `bottom-=${remEnPx} top`,
        toggleClass: {
          targets: targetId,
          className: "active"
        },
      });
    });
  }
}

setupScrollTrigger();
window.addEventListener("resize", setupScrollTrigger);



	const tl = gsap.timeline();

	tl.to(".loading_image_img5", {
		opacity: 1,
		duration: 0.1,
		delay: .6
	})
	.to(".loading_image_img4", {
		opacity: 1,
		duration: 0.1,
		delay: .3
	})
	.to(".loading_image_img3", {
		opacity: 1,
		duration: 0.1,
		delay: .3
	})
	.to(".loading_image_img2", {
		opacity: 1,
		duration: 0.1,
		delay: .3
	})
	.to(".loading_image_img1", {
		opacity: 1,
		duration: 0.1,
		delay: .3
	})
	.to(".loading", {
		opacity: 0,
		duration: 1,
		zIndex: -99,
		delay: 1.2
	})
	.from(".main_image_kv, .header_logo, .drawer_menu_btn", {
		opacity: 0,
		filter: "blur(20px)",
		duration: 1,
		delay: .5
	})
	.from(".main_image_animation1", {
		opacity: 0,
		filter: "blur(20px)",
		duration: 0.5,
		delay: 0.3
	})
	.from(".main_image_animation2", {
		opacity: 0,
		filter: "blur(20px)",
		duration: 0.5,
		delay: 0.3
	}, "-=0.3")
	.from(".main_image_animation3", {
		opacity: 0,
		filter: "blur(20px)",
		duration: 0.5,
		delay: 0.3
	}, "-=0.3")
	.from(".main_image_animation4", {
		opacity: 0,
		filter: "blur(20px)",
		duration: 0.5,
		delay: 0.3
	}, "-=0.3")
	.from(".main_image_logo, .main_image_text", {
		opacity: 0,
		filter: "blur(20px)",
		duration: 1,
		delay: 0.3
	})
	.from(".main_image_title", {
		opacity: 0,
		filter: "blur(20px)",
		duration: 1,
		delay: 0
	});



const progress = { value: 0 };
const tl2 = gsap.timeline({
  onUpdate: () => {
    document.querySelector(".percentage p").textContent = `${Math.round(progress.value)}`;
    document.querySelector(".progress-bar").style.width = `${progress.value}%`;
  },
  onComplete: () => {
    gsap.to("#loader", {
      opacity: 0,
      duration: 0.5,
      onComplete: () => {
        document.getElementById("loader").style.display = "none";
      }
    });
  }
});

// 段階的に進捗を変える
tl2.to(progress, { value: 28, duration: .6, ease: "power1.out" })
  .to(progress, { value: 43, duration: .6, ease: "power2.inOut" })
	.to(progress, { value: 66, duration: .8, ease: "power3.out" })
	.to(progress, { value: 89, duration: .6, ease: "power1.inOut" })
  .to(progress, { value: 100, duration: 1.2, ease: "power4.out" });


	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const $iframe = $(entry.target);
				const originalSrc = $iframe.data('url');

				// 再生開始（srcを再設定）
				$iframe.attr('src', originalSrc + '?autoplay=1&mute=1&rel=0');
			}
		});
	}, {
		threshold: 0.5 // 50%以上見えたら発火
	});

	// 対象の iframe に observer を適用
	$('iframe[data-url]').each(function () {
		observer.observe(this);
	});


	gsap.from(".story_title1 span", {
		opacity: 0,
		duration: 1.2,
		ease: "power2.out",
		stagger: {
			from: "random",
			amount: 1,
		},
		scrollTrigger: {
			trigger: ".story_title1",
			start: "top 80%"
		}
	});
	const items2 = Array.from(document.querySelectorAll(".story_title1 span"));
	const shuffled2 = items2.sort(() => Math.random() - 0.5);
	shuffled2.forEach((el, i) => {
		gsap.to(el, {
			scrollTrigger: {
				trigger: ".story_title1",
				start: "top 80%"
			},
			duration: 1,
			ease: "power2.out",
			delay: i * 0.1,
			onComplete: () => {
				el.classList.add("active");
			}
		});
	});

	gsap.from(".story_title2 span", {
		opacity: 0,
		duration: 1.2,
		ease: "power2.out",
		stagger: {
			from: "random",
			amount: 1,
		},
		scrollTrigger: {
			trigger: ".story_title2",
			start: "top 80%"
		}
	});
	const items3 = Array.from(document.querySelectorAll(".story_title2 span"));
	const shuffled3 = items3.sort(() => Math.random() - 0.5);
	shuffled3.forEach((el, i) => {
		gsap.to(el, {
			scrollTrigger: {
				trigger: ".story_title2",
				start: "top 80%"
			},
			duration: 1,
			ease: "power2.out",
			delay: i * 0.1,
			onComplete: () => {
				el.classList.add("active");
			}
		});
	});

	gsap.from(".story_text3", {
		filter: "blur(20px)",
		opacity: 0,
		duration: 1,
		scrollTrigger: {
			trigger: ".story_text3",
			start: "top 80%"
		}
	});
	gsap.from(".story_text4", {
		filter: "blur(20px)",
		opacity: 0,
		duration: 1,
		scrollTrigger: {
			trigger: ".story_text4",
			start: "top 80%"
		}
	});
	gsap.from(".story_text5", {
		filter: "blur(20px)",
		opacity: 0,
		duration: 1,
		scrollTrigger: {
			trigger: ".story_text5",
			start: "top 80%"
		}
	});

	const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
	const elList = document.querySelectorAll(".story_code_text");

	function randomChar() {
		return chars[Math.floor(Math.random() * chars.length)];
	}

	function scrambleText(target, duration = 1000, interval = 50) {
		const originalText = target.textContent;
		let frame = 0;
		const totalFrames = duration / interval;

		const timer = setInterval(() => {
			let display = "";

			for (let i = 0; i < originalText.length; i++) {
				if (frame >= totalFrames - originalText.length + i) {
					display += originalText[i];
				} else {
					display += randomChar();
				}
			}

			target.textContent = display;
			frame++;

			if (frame >= totalFrames) {
				clearInterval(timer);
			}
		}, interval);
	}

	elList.forEach(el => {
		ScrollTrigger.create({
			trigger: el,
			start: "top 80%",
			once: true,
			onEnter: () => scrambleText(el, 1500, 60)
		});
	});

	gsap.utils.toArray(".story_img").forEach(target => {
    gsap.from(target, {
    scrollTrigger: {
        trigger: target,
        start: 'top 70%',
    },
      alpha: 0,
      ease: "power2.in",
      duration: 1.5,
    });
  });

	gsap.utils.toArray(".story_img").forEach((target) => {
		gsap.fromTo(
			target,
			{ yPercent: 0 },
			{
				yPercent: -50,
				ease: "power2.in",
				scrollTrigger: {
					trigger: target,
					end: "bottom top",
					scrub: 2,
				},
			}
		);
	});

	document.querySelectorAll(".frame").forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      toggleClass: {targets: el, className: "active"},
      once: true,
    });
  });
	

	gsap.fromTo(
		".movie_image",
		{
			scale: .3,
		},
		{
			scale: 1,
			ease: "none",
			scrollTrigger: {
				trigger: ".section_movie",
				start: "top top",
				end: "bottom-=30% bottom",
				scrub: 1,
			},
		}
	);
	gsap.fromTo(
		".movie_box_scroll_wrapper",
		{
			scale: .3,
		},
		{
			scale: 1,
			ease: "none",
			scrollTrigger: {
				trigger: ".section_movie",
				start: "top top",
				end: "bottom-=30% bottom",
				scrub: 1,
			},
		}
	);

	gsap.from(".movie_box_light", {
		filter: "blur(20px)",
		opacity: 0,
		duration: 1.5,
		stagger: 0.3,
		scrollTrigger: {
			trigger: ".movie_box",
			start: "top 80%",
		}
	});


	$('.slider_campaign').slick({
		infinite: true,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 8000,
		cssEase: "linear",
		slidesToShow: 3,
		swipe: false,
		arrows: false,
		pauseOnFocus: false,
		pauseOnHover: false,
		useTransform: false,
		variableWidth: true,
	});

	$('.store_list_btn').on('click', function () {
		$(this).toggleClass('active');
		$(this).next().slideToggle();
	});

	gsap.from(".section_about_img", {
		filter: "blur(20px)",
		opacity: 0,
		duration: 1.5,
		scrollTrigger: {
			trigger: ".section_about",
			start: "top 80%",
		}
	});

	gsap.from(".about_box_img1", {
		clipPath: "inset(0 0% 100% 0%)",
		duration: 1.2,
		delay: .6,
		scrollTrigger: {
			trigger: ".about_box_right",
			start: "top 80%",
		}
	});
	gsap.from(".about_box_img2", {
		clipPath: "inset(0 0% 100% 0%)",
		duration: 1.2,
		delay: .3,
		scrollTrigger: {
			trigger: ".about_box_right",
			start: "top 80%",
		}
	});

	const items = Array.from(document.querySelectorAll(".code_form_text span"));
	const shuffled = items.sort(() => Math.random() - 0.5);

	shuffled.forEach((el, i) => {
		gsap.to(el, {
			scrollTrigger: {
				trigger: ".code_form_text",
				start: "top 80%"
			},
			duration: 0.3,
			ease: "power2.out",
			delay: i * 0.1,
			onComplete: () => {
				el.classList.add("active");
			}
		});
	});

});

const paragraph = document.querySelector(".scene_title");
const textContent = paragraph.textContent;
const newTextContent = [...textContent]
  .map((char, i) => {
    const span = `<span>${char}</span>`;
    return i === 6 ? span + '<br class="br_sp">' : span;
  })
  .join("");
paragraph.innerHTML = newTextContent;

const items = Array.from(document.querySelectorAll(".scene_title span"));
const shuffled = items.sort(() => Math.random() - 0.5);
shuffled.forEach((el, i) => {
	gsap.to(el, {
		scrollTrigger: {
			trigger: ".scene_title",
			start: "top 80%"
		},
		duration: 0.3,
		ease: "power2.out",
		delay: i * 0.1,
		onComplete: () => {
			el.classList.add("active");
		}
	});
});

const paragraph2 = document.querySelector(".code_form_text");
const textContent2 = paragraph2.textContent;
const newTextContent2 = [...textContent2]
  .map((char, i) => {
    return span = `<span>${char}</span>`;
  })
  .join("");
paragraph2.innerHTML = newTextContent2;

const paragraph3 = document.querySelector(".story_title1");
const textContent3 = paragraph3.textContent;
const cleanedText3 = textContent3.replace(/[ \t\r\n\f\v\u3000]/g, "");
const newTextContent3 = [...cleanedText3]
  .map(char => `<span>${char}</span>`)
  .join("");

paragraph3.innerHTML = newTextContent3;

const paragraph4 = document.querySelector(".story_title2");
const textContent4 = paragraph4.textContent.replace(/[ \t\r\n\f\v\u3000]/g, "");
const newTextContent4 = [...textContent4]
  .map((char, i) => {
    const classAttr = i === 15 ? ' class="block"' : '';
    return `<span${classAttr}>${char}</span>`;
  })
  .join("");

paragraph4.innerHTML = newTextContent4;

function copyButton(elementId) {
	var element = document.getElementById(elementId);
	navigator.clipboard.writeText(element.textContent);
	console.log(element);
}

})();
